import { SET_IS_EDITOR_OPEN, SET_SHORTCUT_DISABLE_STATUS, SET_SHORTCUT_MODAL_OPEN_STATUS } from './shortcutsTypes';

const initialState = {
  isShortcutsDisabled: false,
  isEditorOpen: false,
  shortcutModalStatus: null,
};

const shortcutsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHORTCUT_DISABLE_STATUS:
      return { ...state, isShortcutsDisabled: state.isEditorOpen ? true : action.payload };
    case SET_IS_EDITOR_OPEN:
      return { ...state, isEditorOpen: action.payload };
    case SET_SHORTCUT_MODAL_OPEN_STATUS:
      return { ...state, shortcutModalStatus: action.payload };
    default:
      return { ...state };
  }
};

export default shortcutsReducer;
